'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _typeof = require('@babel/runtime/helpers/typeof');
var logger = require('./logger.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _excluded = ["onChange", "onBlur"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * react-hook-form` event
 *
 * Important: The event type is based on what is, in react-hook-form, internally and in `register().onChange` considered
 *  an event. Technically, it's not a "real" event, and it does not have to be for `react-hook-form`.
 */

/** Returns `true` if the given value is a react-hook-form event */
var isReactHookFormEvent = function isReactHookFormEvent(value) {
  return _typeof__default["default"](value) === 'object' && 'type' in value && 'target' in value;
};

/** `on` function type the user can pass to the modified `register` */

/**
 * `allowCustomOnChanges`
 *
 * This is a function to allow custom `onChanges` in react-hook-form's register function.
 *
 * By passing a custom `onChange` function that returns the desired value to the register's `option`
 * argument, you can use this to register any custom component.
 *
 * **Notes**
 *   * Do not forget to handle undefined / null values in your custom `onChange` function!
 *   * If you do not pass an `onChange`, the default behaviour is used, so it can be used for every component,
 *   custom or not.
 *   * To make sure the types fit, properly type the `onChange`'s parameter.
 *
 * @example
 *  const { register: originalRegister } = useForm();
 *  const register = allowCustomOnChanges(originalRegister);
 *
 *  return (
 *      <DateField name="date" {...register('date', { onChange: (date: DateValue) => date.toDate() })} />
 *  )
 *
 * @example
 *     <Select name="date" {...register('date', { onChange: (option: OnChangeValue) => option?.value })} />
 *
 * @param register - The register function from react-hook-form's `useForm` hook
 * @return A customized `register` function that can be passed a custom `onChange`.
 */
var allowCustomOnChanges = function allowCustomOnChanges(register) {
  return function (name, options) {
    var _ref = options || {},
      givenOnChange = _ref.onChange,
      givenOnBlur = _ref.onBlur,
      rest = _objectWithoutProperties__default["default"](_ref, _excluded);
    var realRegister = register(name, rest);
    try {
      return _objectSpread(_objectSpread({}, realRegister), {}, {
        onChange: function onChange(eventOrValue) {
          // If the given `eventOrValue` is considered an event according to `react-hook-form`'s logic, pass it to the
          // default `onChange` function.
          if (isReactHookFormEvent(eventOrValue)) {
            return realRegister === null || realRegister === void 0 ? void 0 : realRegister.onChange(eventOrValue);
          }
          var fakeEvent = {
            target: {
              name: name,
              value: (givenOnChange === null || givenOnChange === void 0 ? void 0 : givenOnChange(eventOrValue)) || eventOrValue
            },
            type: 'change'
          };
          return realRegister === null || realRegister === void 0 ? void 0 : realRegister.onChange(fakeEvent);
        },
        onBlur: function onBlur(eventOrValue) {
          // If the given `eventOrValue` is considered an event according to `react-hook-form`'s logic, pass it to the
          // default `onBlur` function.
          if (isReactHookFormEvent(eventOrValue)) {
            return realRegister === null || realRegister === void 0 ? void 0 : realRegister.onBlur(eventOrValue);
          }
          var fakeEvent = {
            target: {
              name: name,
              value: (givenOnBlur === null || givenOnBlur === void 0 ? void 0 : givenOnBlur(eventOrValue)) || eventOrValue
            },
            type: 'blur'
          };
          return realRegister === null || realRegister === void 0 ? void 0 : realRegister.onChange(fakeEvent);
        }
      });
    } catch (e) {
      logger.error("Modifying `react-hook-form`s register function failed: ".concat(e), 'allowCustomOnChanges');
      throw e;
    }
  };
};
exports.allowCustomOnChanges = allowCustomOnChanges;